/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetEventViewQuery } from "~/generated/graphql";

type Props = {
  eventId: string;
};

export function useGetEventView({ eventId }: Props) {
  const { data, loading, error, refetch, stopPolling, startPolling } =
    useGetEventViewQuery({
      variables: {
        id: eventId,
      },
      fetchPolicy: "cache-first",
    });

  return {
    event: data?.eventView ?? undefined,
    loading,
    error,
    refetch,
    startPolling,
    stopPolling,
  } as const;
}
